import formularioAgricola from './formulario-agricola';
import adminMenu from './admin-menu';
import supervisorMenu from './supervisor-menu';

// ==============================|| MENU ITEMS ||============================== //

/**
 * Lee el usuario desde localStorage de forma segura.
 */
const getUser = () => {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
};

/**
 * Devuelve los items del menú según el rol actual.
 * IMPORTANTE: llamar en el render, no al importar el módulo.
 */
export const getMenuItems = () => {
  const user = getUser();

  const roleId = user?.role?.id;
  const roleName = (user?.role?.name || '').toString().toLowerCase().trim();

  const isAdmin =
    roleId === 1 ||
    roleName === 'admin' ||
    roleName === 'administrador';

  const isSupervisor =
    roleId === 3 ||
    roleName === 'supervisor';

  if (isAdmin) {
    return { items: [adminMenu, formularioAgricola] };
  }

  if (isSupervisor) {
    return { items: [supervisorMenu, formularioAgricola] };
  }

  return { items: [formularioAgricola] };
};

// Default export legacy por compatibilidad
const menuItems = getMenuItems();
export default menuItems;